module.exports = __webpack_public_path__ + "static/media/ajouterCommande.59a5b3f2.png";